import React from 'react';
import loading from '@dls/assets/lottiefiles/loading.json';
import { Row, Column, Animation } from '@dls/web';
import { StyledRow } from '@/styles';

const AnimationLoader = () => {
  return (
    <StyledRow center="xs">
      <Column xs={6} noGutter>
        <Row center="xs">
           <Animation loop={true} action="play" source={loading} data-testid={'animation-loading'} />         
        </Row>
      </Column>
    </StyledRow>
  );
};

export default AnimationLoader;
